export const remittanceFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['SEARCH_BY'],
  },
  {
    type: 'startDate',
    key: 'start_date',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['POLICY_EFFECTIVITY_DATE'],
  },
  {
    type: 'endDate',
    key: 'end_date',
  },
  {
    type: 'multiSelect',
    key: 'insured_name',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['INSURER_NAME'],
    optionsKey: 'partnerList',
  },
];

export const remittanceMoreFilters = (translations: any) => [
  {
    type: 'multiSelect',
    key: 'source',
    optionsKey: 'lead_types',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['SORUCE_TYPE'],
  },
  {
    type: 'multiSelect',
    key: 'remittance_type',
    optionsKey: 'remittance_type',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['REMITTANCE_TYPE'],
  },
  {
    type: 'multiSelect',
    key: 'status',
    optionsKey: 'remittance_status',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['REMITTANCE_STATUS'],
  },
  {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    roleRestricted: true,
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'user_filter_type',
    optionsKey: 'user_filter_type',
    placeholder: 'Assigned to Role',
    useCustomValueContainer: true,
    roleRestricted: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    roleRestricted: true,
    showWhen: {
      key: 'user_filter_type',
      value: '__ANY__'
    }
  },
];


export const leadListFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder:
      'Search by Policy No, Customer Mobile or Insurance ID or Customer Name',
  },
  {
    type: 'startDate',
    key: 'start_date',
  },
  {
    type: 'endDate',
    key: 'end_date',
  },
  {
    type: 'select',
    key: 'payment_due',
    optionsKey: 'payment_due_in',
    placeholder: 'Payment Due In',
    useCustomValueContainer: true,
  },
  {
    type: 'paymentDue',
    key: 'payment_due_range',
    dependsOn: 'showDueRange',
  },
];

export const leadListMoreFilters = (translations: any) => [
  {
    type: 'createdDate',
    key: 'created_date'
  },
  {
    type: 'followUpDate',
    key: 'follow_upDate'
  },
  {
    type: 'multiSelect',
    key: 'source',
    optionsKey: 'lead_types',
    placeholder: 'Source Type',
    // roleRestricted: true
  },
  {
    type: 'select',
    key: 'created_by',
    optionsKey: 'transformedUserList',
    placeholder: 'Created By',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'insurance_type',
    optionsKey: 'insurance_type',
    placeholder: 'Insurance Type',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'status',
    optionsKey: 'lead_status',
    placeholder: 'Status',
    useCustomValueContainer: true,
  },
  // {
  //   type: 'select',
  //   key: 'insured_name',
  //   optionsKey: 'partnerList',
  //   placeholder: 'Insurer Name',
  //   useCustomValueContainer: true,
  // },
  {
    type: 'multiSelect',
    key: 'agency_id',
    optionsKey: 'agencyList',
    placeholder: 'Agency Name'
  },
  {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    useCustomValueContainer: true,
    roleRestricted: true,
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    roleRestricted: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  },
]

export const paymentFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder: 'Search by Policy No, Customer Mobile or Insurance ID or Customer Name',
  },
  {
    type: 'select',
    key: 'insured_id',
    optionsKey: 'insurerList',
    placeholder: 'Insurer Name',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'payment_due',
    optionsKey: 'payment_due_in',
    placeholder: 'Payment Due In',
    useCustomValueContainer: true,
  },
  {
    type: 'paymentDueFinance',
    key: 'payment_due_range',
    dependsOn: 'showDueRange',
  },
  {
    type: 'multiSelect',
    key: 'source',
    optionsKey: 'lead_types',
    placeholder: 'Source Type',
  },
  {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    useCustomValueContainer: true,
    className:'placeHolderText'
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  },
]

export const reconciliationFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder: 'Search by Policy No, Customer Mobile or Insurance ID or Customer Name',
  },
  {
    type: 'createdOnDate',
    key: 'created_on',
  },
  {
    type: 'reconciliationStartDate',
    key: 'start_date',
    placeholder: 'Start Date',
  },
  {
    type: 'reconciliationEndDate',
    key: 'end_date',
    placeholder: 'End Date',
  },
  {
    type: 'select',
    key: 'attachment',
    optionsKey: 'attachmentFilterList',
    placeholder: 'Attachment',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'status',
    optionsKey: 'statusFilterList',
    placeholder: 'Status',
    useCustomValueContainer: true,
  },
];

export const reconciliationMoreFilters = (translations: any) => [
    {
      type: 'multiSelect',
      key: 'source',
      optionsKey: 'lead_types',
      placeholder: 'Source Type',
    },
   {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  },
];

